module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Pillow-Web-640.c1b6d2fe.jpg";